// extracted by mini-css-extract-plugin
export default {"order_table":"AdminVendorProduct_order_table__eBXIx","header_section":"AdminVendorProduct_header_section__eAhdX","lists_":"AdminVendorProduct_lists___K95ig"};